export default "__VITE_ASSET__e6cEoTXI__"